var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.242 6.242a1.05 1.05 0 0 0 0-1.484L1.79.308A1.05 1.05 0 1 0 .307 1.79l3.71 3.71L.306 9.21a1.05 1.05 0 0 0 1.484 1.483l4.45-4.451z",
  clipRule: "evenodd"
})));
export default SvgRightArrow;